import React, { useContext, useEffect, useState } from "react";
import { GET } from "../../utils/fetchUtil";
import Box from "../../common/box/Box";
import { Column, Row } from "../../common/columns";
import { isTouch } from "../../utils/screenUtil";
import InputField from "../../common/input/InputField";
import { useDebounce } from "../../common/hooks/useDebounce";
import { useTranslation } from "react-i18next";
import Content from "../../common/content/Content";
import { format, isAfter } from "date-fns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-regular-svg-icons";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import Loader from "../../common/loader/Loader";
import { MessageContext } from "../../common/message";
import { getAccessToken } from "../../common/authorization/AuthorizeService";
import Tooltip from "../../common/tooltip/Tooltip";
function RequestArchivePage() {
  const [request, setRequest] = useState(undefined);
  const [archive, setArchive] = useState([]);
  const [query, setQuery] = useState("");
  const debouncedQuery = useDebounce(query, 250);
  const { t } = useTranslation();

  const message = useContext(MessageContext);

  useEffect(() => {
    GET(
      "/archive" +
        (debouncedQuery.length > 0 ? `?query=${encodeURIComponent(debouncedQuery)}` : ""),
      (response) => {
        let sorted = response.sort((a, b) =>
          isAfter(new Date(a.submissionDate), new Date(b.submissionDate)) ? -1 : 1
        );
        setArchive(sorted);
        setRequest(response);
      },
      (error) => {
        message.toggle({
          title: t("requests.reviewDocuments.action.save.error"),
          content: error,
          hideNo: true,
          yesLabel: t("modalMessage.okLabel"),
          onYes: () => {
            message.toggle({});
          },
        });
      }
    );

    return () => setRequest([]);
  }, [debouncedQuery]);

  if (request) {
    return (
      <div className={"ml-2 mr-2"}>
        <div className="mt-2 mb-5 is-flex is-flex-direction-row-reverse">
          <div className="field control" style={{ width: isTouch() ? "100%" : "25%" }}>
            <InputField
              placeholder={t("requests.archivePage.searchInputFieldPlaceholder")}
              onChange={(e) => setQuery(e.currentTarget.value)}
              value={query}
            />
          </div>
        </div>
        <Content isScrollable={true} height={870}>
          {archive.map((request, index) => (
            <Box key={"request" + index} defaultPadding={false}>
              <Row>
                <Column className={"is-size-6"}>{request.title}</Column>
                <Column>
                  {t("requests.archivePage.subject")}: {request.subject}
                </Column>
                {/* <Column>
                  {t("requests.archivePage.registerNumber")}: {request.registerNumber}
                </Column> */}
                <Column>
                  {t("requests.archivePage.receiptDate")}:{" "}
                  {format(new Date(request.receiptDate), "dd.MM.yyyy")}
                </Column>
                <Column>
                  {t("requests.archivePage.confirmationDate")}:{" "}
                  {format(new Date(request.confirmationDate), "dd.MM.yyyy")}
                </Column>
                <Column className={"has-text-right"}>
                  <button className={"button is-light has-background-white"}>
                    <FontAwesomeIcon
                      icon={faLock}
                      size="2x"
                      title={t("requests.archivePage.titleInfo")}
                    />
                  </button>
                  <button
                    target="_blank"
                    className={"button is-light has-background-white"}
                    rel="noopener noreferrer"
                    onClick={async () => {
                      message.toggle({
                        show: true,
                        title: "",
                        content: t("requests.wait.label"),
                        hideNo: true,
                        hideYes: true,
                        isWait: true,
                        hideX: false,
                      });
                      fetch(`${process.env.REACT_APP_GATEWAY_URL}${request.href}`, {
                        method: "GET",
                        headers: {
                          "Request-Origin": "pisarnica",
                          Authorization: "Bearer " + (await getAccessToken()),
                        },
                        mode: "cors",
                        credentials: "include",
                      })
                        .then((response) => response.blob())
                        .then(
                          (file) =>
                            window.open(URL.createObjectURL(file)) &&
                            message.toggle({ show: false })
                        );
                    }}
                  >
                    <Tooltip content={"Rezultat predanog zahtjeva"} direction={"left"}>
                      <FontAwesomeIcon
                        icon={faFilePdf}
                        size="2x"
                        className="has-text-danger ml-4"
                      />
                    </Tooltip>
                  </button>
                </Column>
              </Row>
            </Box>
          ))}
        </Content>
      </div>
    );
  } else {
    return <Loader />;
  }
}

export default RequestArchivePage;
